export const FETCH_DATA_BY_EMAIL = 'FETCH_DATA_BY_EMAIL'
